import { getApolloClient, getWordPressProps, WordPressTemplate } from "@faustwp/core";
import { GetStaticPaths, GetStaticProps } from "next";
import { Main } from "@components";
import { WordPressTemplateProps } from "@/types";
import { REVALIDATE_TIME } from "@/core/constants";
import { getPageWrapperData } from "@/core/pageWrapperCache";
import CoreSitePages from "@/queries/Pages/CoreSitePages";
import { CoreSitePagesQuery } from "@/__generated__/graphql";
import { getUrlLocale } from "@/core/utils";

export default function Page(props: WordPressTemplateProps) {
  return (
    <Main>
      <WordPressTemplate {...props} />
    </Main>
  );
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const url = `/${(ctx.params?.wordpressNode as string[]).join('/')}/`;
  const language = getUrlLocale(url) || 'en';
  const context = { ...ctx, language };
  const pageWrapperData = await getPageWrapperData(language);
  return getWordPressProps({
    ctx: context,
    revalidate: REVALIDATE_TIME,
    props: { pageWrapperData },
  });
};

export const getStaticPaths: GetStaticPaths = async () => {
  const client = getApolloClient();
  const { data } = await client.query<CoreSitePagesQuery>({ query: CoreSitePages });
  const pages = process.env.SKIP_STATIC_GENERATION === 'true' ? [] : data.coreSitePages?.map(page => page?.uri || '') || [];
  return {
    paths: pages.map((slug) => ({ params: { wordpressNode: slug.split('/').filter(Boolean) } })) || [],
    fallback: "blocking",
  };
};
